import React from 'react'

import { tagCard, tagCardText } from './styles'
import { cssClass } from '@/shared/utils/styles'

interface Props {
  label: string | JSX.Element
  onClick?: (label: string) => void
  className?: string[]
  labelClassName?: string[]
}

export const TagCard: React.FC<Props> = ({
  label,
  onClick,
  className = [],
  labelClassName = [],
}) => {
  const handleClick = () => {
    if (typeof label === 'string') {
      onClick && onClick(label)
    }
  }

  return (
    <div className={cssClass([tagCard, ...className])} onClick={handleClick}>
      <span className={cssClass([tagCardText, ...labelClassName])}>
        {label}
      </span>
    </div>
  )
}
